/*
 * StatusDot — one consistent status indicator for the whole app.
 *
 * Replaces the several ad-hoc dot patterns that had drifted apart:
 *   - <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping" />
 *   - <span className="relative flex"><span animate-ping/><span/></span>
 *   - plain coloured dots
 *
 * Colour + glow + optional ping all live here so the visual language stays
 * consistent and reduced-motion (handled in global.css via .animate-ping)
 * applies everywhere at once.
 */
const VARIANT_COLORS = {
  live: "#10b981", // emerald — connected / online / captured
  active: "#3b82f6", // blue — in progress
  warning: "#f59e0b", // amber — attention / uncaptured
  danger: "#ef4444", // red — failed / critical
  idle: "#94a3b8", // slate — inactive
};

export default function StatusDot({
  variant = "live",
  pulse = true,
  size = 6,
  className = "",
}) {
  const color = VARIANT_COLORS[variant] || VARIANT_COLORS.live;
  const dimension = `${size}px`;

  return (
    <span
      className={`relative inline-flex shrink-0 ${className}`}
      style={{ width: dimension, height: dimension }}
    >
      {pulse && (
        <span
          className="absolute inline-flex h-full w-full rounded-full opacity-75 animate-ping"
          style={{ backgroundColor: color }}
        />
      )}
      <span
        className="relative inline-flex h-full w-full rounded-full"
        style={{ backgroundColor: color, boxShadow: `0 0 6px ${color}` }}
      />
    </span>
  );
}
